import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { textVariantMap, textColorMap } from '../../theming';
import { generateTextStyles, readHDSTheme } from '../../utils';

/*
 * This isn't always a styled `p` element. It depends on the value of the `as` prop.
 * As of right now, there isn't a way to conditionally express something like `styled.<as>` (but it does work that way under-the-hood).
 * See https://styled-components.com/docs/api#as-polymorphic-prop
 */
const StyledHDSText = styled.p.withConfig({
  displayName: "HDSText__StyledHDSText",
  componentId: "sc-1cw3346-0"
})(({
  theme,
  $variant,
  $color,
  $display,
  $textTransform,
  $alignment,
  $wordBreak
}) => generateTextStyles({
  fontSize: readHDSTheme(theme).UNSTABLE_HDS[textVariantMap[$variant]].fontSize,
  fontWeight: readHDSTheme(theme).UNSTABLE_HDS[textVariantMap[$variant]].fontWeight,
  fontFamily: readHDSTheme(theme).UNSTABLE_HDS[textVariantMap[$variant]].fontFamily,
  lineHeight: readHDSTheme(theme).UNSTABLE_HDS[textVariantMap[$variant]].lineHeight,
  color: readHDSTheme(theme).UNSTABLE_HDS[textColorMap[$color]],
  display: $display,
  textTransform: $textTransform,
  textAlign: $alignment,
  wordBreak: $wordBreak
}));
export const HDSText = ({
  as = 'p',
  variant = 'body',
  color = 'default',
  display,
  textTransform,
  alignment,
  wordBreak,
  'data-test-id': dataTestid,
  children
}) => {
  return /*#__PURE__*/_jsx(StyledHDSText, {
    as: as,
    $variant: variant,
    $color: color,
    $display: display,
    $textTransform: textTransform,
    $alignment: alignment,
    $wordBreak: wordBreak,
    "data-test-id": dataTestid,
    children: children
  });
};